import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Modal from 'react-responsive-modal';
import "../articles/articles.css";
import "./homePage.css";

import moment from 'moment';
const format = 'YYYY-MM-DD HH:mm';
const now = moment();
class SliderItem extends Component {
  state={
    open:false,
  }
  onOpenModal = () => {
      this.setState({ open: true });
    };

    onCloseModal = () => {
      this.setState({ open: false });
    };

    constructor(props){
      super(props);
    }
    render() {
    	return (
	      <div className="SliderItem">
        <Modal open={this.state.open} onClose={this.onCloseModal}>
          <div dangerouslySetInnerHTML={{__html: "<h2 class='BlogTitle'>"+this.props.blog.title+"</h2><p class='BlogDate'>"+moment(this.props.blog.date,format).format("dddd Do, MMM YYYY")+"</p><img class='BlogImage' src='"+this.props.blog.image+"'/>"+"<p class='BlogText'>"+this.props.blog.htmlcontent+"</p>"}} ></div>
        </Modal>

          <div className="SliderItemImage">
            <img src={this.props.blog.image} alt=""/>
          </div>


          <div className="SliderItemBlog">

            <div className="SliderItemTitle">{this.props.blog.title}</div>
            <div className="SliderItemReadMore" onClick={this.onOpenModal} ><p>READ MORE</p></div>
          </div>

            <div className="SliderItemOverlay">
            </div>
	      </div>
	    );
    }
}

export default SliderItem;
/*
<div className="SliderItemTitle">{this.props.blog.title}</div>
<div className="SliderItemDesc">{this.props.blog.desc}</div>
*/
